import React from "react";


import Union from "../assets/Union.png";
import Ellipse from "../assets/exp1.svg";
import { Carousel } from "antd";
import {
  SLIDER_IMAGE_1,
  SLIDER_IMAGE_2,
  SLIDER_IMAGE_3,
  SLIDER_IMAGE_4,
} from "../ImagesSrc";

const ImagesSlider = () => {
  return (
    <div className="right">
      <img alt="" src={Union} className="img31" />
      <img alt="" src={Ellipse} className="img1" />
      <div className="para-text1">
        Growing your people,
        <br />
        growing your company, together
      </div>

      <div className="carousel-holder">
        <Carousel autoplay>
          <div>

            <img alt="" src={SLIDER_IMAGE_1} className="peopleImg" />
          </div>
          <div>
            <img alt="" src={SLIDER_IMAGE_2} className="peopleImg" />
          </div>
          <div>
            <img alt="" src={SLIDER_IMAGE_3} className="peopleImg" />
          </div>
          <div>
            <img alt="" src={SLIDER_IMAGE_4} className="peopleImg" />

          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default ImagesSlider;
